<template>
  <section class="TcMyAppointments">
    <nav class="tabs mt-5">
      <span @click="$root.setPage('new-appointment')" class="tab">Solicitar cita</span>
      <span class="tab active">Ver mis citas</span>
    </nav>
    <div class="appointments-list mt-12">
      <div v-for="appo in appointments" :key="appo.id"
        :style="{'border-left':`4px solid ${$root.delegationColor(appo.delegation_id)}`}"
        class="appointment w-2/4 mx-auto bg-white px-5 pt-10 pb-5 mb-5 rounded-xl shadow-md">
        <div class="flex" >
          <svg class="h-8 w-8" :style="{color:$root.delegationColor(appo.delegation_id)}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="12" fill="currentColor"/>
          </svg>
          <div class="pl-5 flex-grow">
            <h3 class="text-2xl mb-3">{{ appo.delegation_name }}</h3>
            <div class="icon_with_text mb-1">
              <svg class="h-6 w-6 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <span>{{appo.reserved_at.toDate()}}</span>
            </div>
            <div class="icon_with_text mb-1">
              <svg class="h-6 w-6 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>{{appo.reserved_at.toTime()}}</span>
            </div>
            <div class="icon_with_text mb-1">
              <svg class="h-6 w-6 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path v-if="appo.type == 'phone_call'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                <path v-if="appo.type != 'phone_call'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path v-if="appo.type != 'phone_call'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span>{{ appo.type == 'phone_call' ? 'Telefónica':'Presencial'}}</span>
            </div>
            <div class="mt-6">
              <h4 class="font-bold">Observaciones:</h4>
              <p>{{appo.reason}}</p>
            </div>
          </div>
        </div>
        <button
          @click="cancelAppointment(appo.id)"
          class="mt-12 bg-white hover:text-white border-primary text-primary mx-auto px-10 w-1/2 py-2 text-xl"
          >
          Cancelar cita
        </button>
      </div>
      <div v-if="appointments.length==0">
        <h2 class="text-center">EN ESTE MOMENTO NO TIENE CITAS PENDIENTES</h2>
        <div class="text-center mt-6">
          <a href="#" @click="$root.setPage('new-appointment')" class="text-primary">Solicitar cita</a>
        </div>
      </div>
    </div>
    <tc-cancel-appointment v-if="canceling" :appointment="selectedAppointment"></tc-cancel-appointment>
  </section>
</template>

<script>
import TcCancelAppointment from './TcCancelAppointment.vue';

export default {
  name: 'TcMyAppointments',
  components: {
    TcCancelAppointment,
  },
  data () {
    return {
      canceling: false,
      appointments: [],
      selectedAppointment: null,
    }
  },
  mounted () {
    //console.log('MOUNTED MY APPOINTMENTS', this.$root.my_appointments_url())
    this.$root.loadDelegations().then(response => {
      //console.log('TcMyAppointments loadDelegations', response)
      fetch(this.$root.my_appointments_url()).then(res => res.json()).then((json)=> {
        //console.log('MY APPOINTMENTS JSON', json)
        this.appointments = json.sort(function(a,b) {
          return a.reserved_at.toIsoDate().localeCompare(b.reserved_at.toIsoDate())
        });
      })
    })
  },
  methods: {
    cancelAppointment: function(appointment_id) {
      //console.log('ER APPO', appointment_id)
      this.selectedAppointment = this.appointments.find(function(a) {
        return a.id == appointment_id
      })
      this.canceling = true;
    },
    deleteAppointment: function(appointment_id) {
      //console.log('deleteAppointment',appointment_id);
      //var index=false;
      var i = 0;
      for(i=0; i<this.appointments.length; i++) {
        if(this.appointments[i].id==appointment_id) {
          //index=true;
          break;
        }
      }
      //console.log('I',i, this.appointments.length);
      if(i<this.appointments.length) {
        var appo_id = this.appointments[i].id;
        //console.log('DELETE URL', appo_id, this.$root.delete_appointment_url());
        //console.log('TOKEN', this.$root.access_token);
        //console.log('DDELEE', this.$root.delete_appointment_url())
        fetch('/post.php',{
          method: 'POST',
          body: JSON.stringify({
            access_token: this.$root.access_token,
            action: 'delete_appointment',
            url: this.$root.delete_appointment_url(),
            params: {
              appointment_id: appo_id,
            }
          })
        }).then(response => response.json()).then(json => {
          //console.log('RESPONSE JSON', json);
        }).catch(error => {
          //console.error('SE HA PRODUCIDO UN ERROR', error)
        })
        this.appointments.splice(i,1)
      }
      this.canceling = false;
    },
  }
}
</script>